module.exports = __webpack_public_path__ + "static/delete_api_key-0a736c2a06413687e51f6e9101b3d5d9.png";